import * as types from './auth.actionTypes';
import { removeToken } from '../../helpers';
import chatService from '../../chatService';

const initState = {
  user: null,
  isAuthorizing: false,
  chatToken: null,
  bankAccounts: [],
  creditCards: [],
  isFetchingCreditCards: false,
  notificationCount: 0,
  countryList: ["IOL"],
  usaStates: ['IL']
};

export default (state = initState, action) => {
  switch (action.type) {
    case types.GET_CURRENT_USER_REQUEST:
    case types.LOGIN_USER_REQUEST:
      return {
        ...state,
        isAuthorizing: true,
      };
    case types.GET_CURRENT_USER_SUCCESS:
    case types.GET_CURRENT_PRIVACY_REQUEST:
    case types.LOGIN_USER_SUCCESS:
      return {
        ...state,
        user: action.user,
        isAuthorizing: false,
      };

      case types.FETCH_COUNTRY_LIST_SUCCESS:
        return {
          ...state,
          countryList: action.data
        }

        case types.FETCH_STATE_LIST_SUCCESS:
          return {
            ...state,
            usaStates: action.data
          }


    case types.GET_CURRENT_USER_FAILURE:
    case types.LOGIN_USER_FAILURE:
      return {
        ...state,
        isAuthorizing: false,
      };

    case types.LOGOUT_USER:
      removeToken();
      return {
        ...state,
        user: null,
        chatToken: null,
      };
    case types.SET_CHAT_TOKEN:
      return {
        ...state,
        chatToken: action.token,
      };
    case types.UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        user: action.user,
      };
    case types.TOGGLE_SUBSCRIBE_USER_SUCCESS:
      return {
        ...state,
        user: { ...state.user, subscribed: action.subscribed },
      };
    case types.FETCH_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        bankAccounts: [action.data],
      };
    case types.ADD_BANK_ACCOUNT_SUCCESS:
      
      return {
        ...state,
        bankAccounts: [ action.data],
        // user: { ...state.user, verified: state.user.verified == null ? 0 : state.user.verified },
      };
    case types.DELETE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        bankAccounts: state.bankAccounts.filter(el => el.id !== action.id),
      };
    case types.FETCH_NOTIFICATION_COUNT:
      return {
        ...state,
        notificationCount: action.count['unread'],
      };
    case types.FETCH_CREDIT_CARDS_REQUEST:
      return {
        ...state,
        isFetchingCreditCards: true,
      };
    case types.FETCH_CREDIT_CARDS_SUCCESS:
      return {
        ...state,
        creditCards: action.data,
        isFetchingCreditCards: false,
      };
    case types.FETCH_CREDIT_CARDS_FAILURE:
      return {
        ...state,
        isFetchingCreditCards: false,
      };
    case types.ADD_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        creditCards: [...state.creditCards, action.data],
      };
    case types.DELETE_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        creditCards: state.creditCards.filter(el => el.customerPaymentProfileId !== action.id),
      };
    case types.DEFAULT_CREDIT_CARD_CHANGE_SUCCESS:
      return {
        ...state,
        creditCards: state.creditCards.map(el => ({
          ...el,
          defaultPaymentProfile: el.customerPaymentProfileId === action.id,
        })),
      };
    default:
      return state;
  }
};
